// orders
export const RESTORE_ACCESSORIES_ORDERS_PAGE = '@@toyota/RESTORE_ACCESSORIES_ORDERS_PAGE';
export const CHANGE_ACCESSORIES_ORDERS_PAGE = '@@toyota/CHANGE_ACCESSORIES_ORDERS_PAGE';
export const RESIZE_ACCESSORIES_ORDERS_PAGE = '@@toyota/RESIZE_ACCESSORIES_ORDERS_PAGE';
export const CHANGE_ACCESSORIES_ORDERS_DATE = '@@toyota/CHANGE_ACCESSORIES_ORDERS_DATE';
export const CHANGE_ACCESSORIES_ORDERS_DATE_END = '@@toyota/CHANGE_ACCESSORIES_ORDERS_DATE_END';
export const LOADING_ACCESSORIES_ORDERS = '@@toyota/LOADING_ACCESSORIES_ORDERS';
export const LOADED_ACCESSORIES_ORDERS = '@@toyota/LOADED_ACCESSORIES_ORDERS';
export const LOADED_ACCESSORIES_ORDERS_FAILED = '@@toyota/LOADED_ACCESSORIES_ORDERS_FAILED';
export const GENERATING_ACCESSORIES_ORDERS = '@@toyota/GENERATING_ACCESSORIES_ORDERS';
export const GENERATED_ACCESSORIES_ORDERS = '@@toyota/GENERATED_ACCESSORIES_ORDERS';
export const GENERATED_ACCESSORIES_ORDERS_FAILED = '@@toyota/GENERATED_ACCESSORIES_ORDERS_FAILED';
export const PRINTING_ACCESSORIES_ORDERS = '@@toyota/PRINTING_ACCESSORIES_ORDERS';
export const PRINTED_ACCESSORIES_ORDERS = '@@toyota/PRINTED_ACCESSORIES_ORDERS';
export const PRINTED_ACCESSORIES_ORDERS_FAILED = '@@toyota/PRINTED_ACCESSORIES_ORDERS_FAILED';
export const CHANGE_CHASSIS_MARKED = '@@toyota/CHANGE_CHASSIS_MARKED';
export const CHANGE_ORDERS_MARKED = '@@toyota/CHANGE_ORDERS_MARKED';
export const CANCELLING_ORDER = '@@toyota/CANCELLING_ORDER';
export const CANCELLED_ORDER = '@@toyota/CANCELLED_ORDER';
export const CANCELLED_ORDER_FAILED = '@@toyota/CANCELLED_ORDER_FAILED';
export const CLEAN_ACCESSORIES_ORDERS_LIST = '@@toyota/CLEAN_ACCESSORIES_ORDERS_LIST';
export const FETCHING_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN =
  '@@toyota/FETCHING_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN';
export const FETCHED_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN =
  '@@toyota/FETCHED_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN';
export const FETCHED_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN_FAILED =
  '@@toyota/FETCHED_CLOSED_PENDING_ORDERS_LIST_BY_TECHNICIAN_FAILED';

// techniciansAssignment
export const FETCHING_TECHNICIANS = '@@toyota/FETCHING_TECHNICIANS';
export const FETCHED_TECHNICIANS = '@@toyota/FETCHED_TECHNICIANS';
export const FETCHED_TECHNICIANS_FAILED = '@@toyota/FETCHED_TECHNICIANS_FAILED';
export const FETCHING_TASKS_BY_ORDER = '@@toyota/FETCHING_TASKS_BY_ORDER';
export const FETCHED_TASKS_BY_ORDER = '@@toyota/FETCHED_TASKS_BY_ORDER';
export const FETCHED_TASKS_BY_ORDER_FAILED = '@@toyota/FETCHED_TASKS_BY_ORDER_FAILED';
export const ADDING_TECHNICIANS_TO_TASKS_BY_ORDER = '@@toyota/ADDING_TECHNICIANS_TO_TASKS_BY_ORDER';
export const ADDED_TECHNICIANS_TO_TASKS_BY_ORDER = '@@toyota/ADDED_TECHNICIANS_TO_TASKS_BY_ORDER';
export const ADDED_TECHNICIANS_TO_TASKS_BY_ORDER_FAILED = '@@toyota/ADDED_TECHNICIANS_TO_TASKS_BY_ORDER_FAILED';

// timeMarked
export const FETCHING_ORDER_AND_TASK_STATUS = '@@toyota/FETCHING_ORDER_AND_TASK_STATUS';
export const FETCHED_ORDER_AND_TASK_STATUS = '@@toyota/FETCHED_ORDER_AND_TASK_STATUS';
export const FETCHED_ORDER_AND_TASK_STATUS_FAILED = '@@toyota/FETCHED_ORDER_AND_TASK_STATUS_FAILED';
export const FETCHING_PENDING_ACCESSORIES_ORDERS = '@@toyota/FETCHING_PENDING_ACCESSORIES_ORDERS';
export const FETCHED_PENDING_ACCESSORIES_ORDERS = '@@toyota/FETCHED_PENDING_ACCESSORIES_ORDERS';
export const FETCHED_PENDING_ACCESSORIES_ORDERS_FAILED = '@@toyota/FETCHED_PENDING_ACCESSORIES_ORDERS_FAILED';
export const FETCHING_PENDING_ORDERS_LIST_BY_TECHNICIAN = '@@toyota/FETCHING_PENDING_ORDERS_LIST_BY_TECHNICIAN';
export const FETCHED_PENDING_ORDERS_LIST_BY_TECHNICIAN = '@@toyota/FETCHED_PENDING_ORDERS_LIST_BY_TECHNICIAN';
export const FETCHED_PENDING_ORDERS_LIST_BY_TECHNICIAN_FAILED =
  '@@toyota/FETCHED_PENDING_ORDERS_LIST_BY_TECHNICIAN_FAILED';
export const ADDING_ORDER_TASK_PROGRESS = '@@toyota/ADDING_ORDER_TASK_PROGRESS';
export const ADDED_ORDER_TASK_PROGRESS = '@@toyota/ADDED_ORDER_TASK_PROGRESS';
export const ADDED_ORDER_TASK_PROGRESS_FAILED = '@@toyota/ADDED_ORDER_TASK_PROGRESS_FAILED';

// stock download
export const FETCHING_PARTS_BY_ORDER = '@@toyota/FETCHING_PARTS_BY_ORDER';
export const FETCHED_PARTS_BY_ORDER = '@@toyota/FETCHED_PARTS_BY_ORDER';
export const FETCHED_PARTS_BY_ORDER_FAILED = '@@toyota/FETCHED_PARTS_BY_ORDER_FAILED';
export const DOWNLOADING_STOCK_TO_ORDER = '@@toyota/DOWNLOADING_STOCK_TO_ORDER';
export const DOWNLOADED_STOCK_TO_ORDER = '@@toyota/DOWNLOADED_STOCK_TO_ORDER';
export const DOWNLOADED_STOCK_TO_ORDER_FAILED = '@@toyota/DOWNLOADED_STOCK_TO_ORDER_FAILED';

// kanban
export const FETCHING_KANBAN_ORDERS = '@@toyota/FETCHING_KANBAN_ORDERS';
export const FETCHED_KANBAN_ORDERS = '@@toyota/FETCHED_KANBAN_ORDERS';
export const FETCHED_KANBAN_ORDERS_FAILED = '@@toyota/FETCHED_KANBAN_ORDERS_FAILED';
export const FETCHING_KANBAN_ORDER_DETAIL = '@@toyota/FETCHING_KANBAN_ORDER_DETAIL';
export const FETCHED_KANBAN_ORDER_DETAIL = '@@toyota/FETCHED_KANBAN_ORDER_DETAIL';
export const FETCHED_KANBAN_ORDER_DETAIL_FAILED = '@@toyota/FETCHED_KANBAN_ORDER_DETAIL_FAILED';

// invoicing
export const FETCHING_ORDERS_BY_COMMERCIAL_ORDER = '@@toyota/FETCHING_ORDERS_BY_COMMERCIAL_ORDER';
export const FETCHED_ORDERS_BY_COMMERCIAL_ORDER = '@@toyota/FETCHED_ORDERS_BY_COMMERCIAL_ORDER';
export const FETCHED_ORDERS_BY_COMMERCIAL_ORDER_FAILED = '@@toyota/FETCHED_ORDERS_BY_COMMERCIAL_ORDER_FAILED';
export const CREATING_ACCESSORIES_INVOICE = '@@toyota/CREATING_ACCESSORIES_INVOICE';
export const CREATED_ACCESSORIES_INVOICE = '@@toyota/CREATED_ACCESSORIES_INVOICE';
export const CREATED_ACCESSORIES_INVOICE_FAILED = '@@toyota/CREATED_ACCESSORIES_INVOICE_FAILED';
